/**
 * Which quote number a save should carry (spec 2026-09-09 numbering §4.5).
 *
 * - No number yet → allocate (`{L}QT-YYYY-NNNN`, letter from the entity).
 * - DRAFT with a number → keep the serial, swap the letter to the CURRENT
 *   entity (a draft is not an issued document).
 * - Anything else (SENT and every later status) → locked; versions inherit.
 * - A legacy `QTE-` number is never re-lettered (reletterQuoteNumber no-ops).
 */

import { entityLetter, reletterQuoteNumber } from '../../shared/documentNumbering';

export const resolveQuoteNumberForSave = (args: {
  existing: string | null | undefined;
  status: string | null | undefined;
  issuedCompany: string;
}): { number: string | undefined; allocate: boolean } => {
  if (!args.existing) return { number: undefined, allocate: true };
  if (args.status === 'DRAFT') {
    return {
      number: reletterQuoteNumber(args.existing, entityLetter(args.issuedCompany)),
      allocate: false,
    };
  }
  return { number: args.existing, allocate: false };
};
